/* eslint-disable */
import React from "react";
import RichTextEditor, { BaseKit } from "reactjs-tiptap-editor";
import { Blockquote } from "reactjs-tiptap-editor/blockquote";
import { Bold } from "reactjs-tiptap-editor/bold";
import { BulletList } from "reactjs-tiptap-editor/bulletlist";
import { Code } from "reactjs-tiptap-editor/code";
import { Color } from "reactjs-tiptap-editor/color";
import { FontSize } from "reactjs-tiptap-editor/fontsize";
import { Heading } from "reactjs-tiptap-editor/heading";
import { Highlight } from "reactjs-tiptap-editor/highlight";
import { History } from "reactjs-tiptap-editor/history";
import { HorizontalRule } from "reactjs-tiptap-editor/horizontalrule";
import { Image } from "reactjs-tiptap-editor/image";
import { Italic } from "reactjs-tiptap-editor/italic";
import { LineHeight } from "reactjs-tiptap-editor/lineheight";
import { Link } from "reactjs-tiptap-editor/link";
import { ListItem } from "reactjs-tiptap-editor/listitem";
import { OrderedList } from "reactjs-tiptap-editor/orderedlist";
import { Selection } from "reactjs-tiptap-editor/selection";
import { SlashCommand } from "reactjs-tiptap-editor/slashcommand";
import { Strike } from "reactjs-tiptap-editor/strike";
import { SubAndSuperScript } from "reactjs-tiptap-editor/subandsuperscript";
import { Table } from "reactjs-tiptap-editor/table";
import { TaskList } from "reactjs-tiptap-editor/tasklist";
import { TextAlign } from "reactjs-tiptap-editor/textalign";
import { TextBubble } from "reactjs-tiptap-editor/textbubble";
import { TextUnderline } from "reactjs-tiptap-editor/textunderline";
import { TrailingNode } from "reactjs-tiptap-editor/trailingnode";
//import { TextDirection } from "reactjs-tiptap-editor/extension-bundle";
//import "react-image-crop/dist/ReactCrop.css";
// codeblock
//FormatPainter,
//Document
//Iframe
// Mention
// Katex
//Video
// SearchAndReplace
// FontFamily
// Clear
// MoreMark
// ColumnActionButton
// Emoji
// TableOfContents
// Indent,
import "./tiptap-editor.css";
import "./style.scss";

const PostEditor = props => {
  const { content, setContent, setImages } = props;
  const extensions = [
    BaseKit.configure({
      placeholder: { showOnlyCurrent: true },
      characterCount: { limit: 50000 },
    }),
    History,
    Bold,
    Italic,
    TextUnderline,
    Color,
    Heading,
    FontSize,
    LineHeight,
    Highlight,
    TextAlign,
    Blockquote,
    Link,
    ListItem,
    BulletList,
    OrderedList,
    Code,
    Selection,
    SlashCommand,
    Strike,
    SubAndSuperScript,
    TaskList,
    HorizontalRule,
    Image.configure({
      upload: files => {
        return new Promise(resolve => {
          let objUrl = URL.createObjectURL(files);
          files["objUrl"] = objUrl;
          setImages(old => [...old, files]);
          setTimeout(() => {
            resolve(objUrl);
          }, 500);
        });
      },
    }),
    TextBubble,
    TrailingNode,
    Table,
  ];

  const onChangeContent = value => {
    setContent(value);
  };
  const customOptions = {
    // onUpdate: ({ editor }) => console.log("Content updated:", editor.getText()),
    // onSelectionUpdate: ({ editor }) =>
    //   console.log("Selection updated:", editor.getText()),
    // onFocus: () => console.log("Editor focused"),
    //onBlur: () => console.log("Editor blurred"),
    editable: true,
    autofocus: "start",
  };

  return (
    <div className="eventsPost-editor">
      <RichTextEditor
        output="html"
        content={content}
        onChangeContent={onChangeContent}
        extensions={extensions}
        useEditorOptions={customOptions}
        dark={true}
        contentClass="eventsPost-editor-content"
        minHeight={500}
      />
    </div>
  );
};

export default PostEditor;
